<template>
  <b-container
    class="commutator-parameters"
    fluid
  >
    <div class="commutator-parameters__title">
      {{ $t('general.general') }}
    </div>
    <div
      v-if="cards.length"
      class="commutator-parameters__cards"
    >
      <engineering-card
        v-for="card in cards"
        :key="card.name"
        :detail="card"
      />
    </div>
    <s-empty-list
      v-else
      :loading="loading"
    />
  </b-container>
</template>

<script>
import Service from '@/domain/services/installation/engineering/commutatorTemperatureDifferential/commutatorTemperatureDifferentialService';
import eventBus from '@/services/globalEventBus';
import events from '@/domain/events/engineering';
import LoadingMixin from '@/services/loadingMixin';
import EngineeringCard from '../EngineeringCard';

export default {
  name: 'CommutatorTemperatureDifferentialParameters',
  components: {
    EngineeringCard,
  },
  mixins: [
    LoadingMixin,
  ],
  data: () => ({
    cards: [],
  }),
  created() {
    this.getParameters();
    this.initListener();
  },
  beforeDestroy() {
    this.removeListener();
  },
  methods: {
    getParameters() {
      this.startLoading();
      return Service.getParameters(this.$route.params.assetModuleId).then((response) => {
        this.cards = response;
      }).finally(() => {
        this.endLoading();
      });
    },
    initListener() {
      eventBus.on(events.refreshDataTab, this.refreshDataEvent, this);
    },
    removeListener() {
      eventBus.off(events.refreshDataTab, this.refreshDataEvent, this);
    },
    refreshDataEvent() {
      this.getParameters();
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/mobile-first"

  .commutator-parameters
    margin: 0 0 10px
    &__title
      margin: 10px 0
      padding: 2px 10px
      border-radius: 5px
      font-weight: bold
      background-color: var(--color-background-dark)
    &__cards
      display: grid
      gap: 18px
      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr))
      +media-min-sm
        margin: 0 10px
    &__card
      padding: 10px
      border: 1px solid var(--color-border-dark)
      border-radius: 5px
      min-height: 160px
      display: inline-flex
      flex-direction: column
      justify-content: center
      align-items: center
    &__card-value
      font-size: 2.5rem
    &__card-unit
      font-size: 1.8rem
    &__card-name
      text-align: center
      margin-top: 10px
      font-size: .9rem
      font-weight: bold
</style>
